// ai ENTRY POINT
// Entry points need to exists inside of webpack.config.js under module.exports, entry:
// Entry points is meant for the translations object. ai.js is mean for custom functions for the ai hub.

require('../partials/_ai.scss');
const aiSpecificJS = require('../scriptPartials/ai.js');
const onbrandScripts = require('../onbrand.js');

//only use if there are descrepencies between different language sites.
function generateLinks(arr) {
  return arr.map((link) => `<a href="${link.href}" id="${link.id}">${link.label}</a>`).join('');
}

const translations = {
  header: {},
  footer: {},
};

aiSpecificJS();
onbrandScripts.initOnbrand(translations, production);



// WEBPACK FOOTER //
// ./entryPoints/ai.js